/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CouponInfoObj model module.
 * @module model/CouponInfoObj
 * @version v1
 */
class CouponInfoObj {
    /**
     * Constructs a new <code>CouponInfoObj</code>.
     * @alias module:model/CouponInfoObj
     * @param coupon {Number} int64
     */
    constructor(coupon) { 
        
        CouponInfoObj.initialize(this, coupon);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, coupon) { 
        obj['Coupon'] = coupon;
    }

    /**
     * Constructs a <code>CouponInfoObj</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CouponInfoObj} obj Optional instance to populate.
     * @return {module:model/CouponInfoObj} The populated <code>CouponInfoObj</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CouponInfoObj();

            if (data.hasOwnProperty('Coupon')) {
                obj['Coupon'] = ApiClient.convertToType(data['Coupon'], 'Number');
            }
            if (data.hasOwnProperty('CouponInfo')) {
                obj['CouponInfo'] = ApiClient.convertToType(data['CouponInfo'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CouponInfoObj</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CouponInfoObj</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CouponInfoObj.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['CouponInfo'] && !(typeof data['CouponInfo'] === 'string' || data['CouponInfo'] instanceof String)) {
            throw new Error("Expected the field `CouponInfo` to be a primitive type in the JSON string but got " + data['CouponInfo']);
        }

        return true;
    }


}

CouponInfoObj.RequiredProperties = ["Coupon"];

/**
 * int64
 * @member {Number} Coupon
 */
CouponInfoObj.prototype['Coupon'] = undefined;

/**
 * MaxLength:50
 * @member {String} CouponInfo
 */
CouponInfoObj.prototype['CouponInfo'] = undefined;






export default CouponInfoObj;

